/*
common/lib/utils/textkeys

usage:
To split a string containing ':' and ',' so that some of these chars
are preserved, some custom separators are used:
"key:value, key2:value" is then supplied with custom separators:
"key__ENDOFKEY__value__ENDOFVALUE"
see also 'textkeys-payment.mustache'
TODO: this solution is considered a workaround in wait for a post-mvp solution where
textkeys are provided in consistency with other parts of the site. This workaround
is here to get serverside rendered data.
*/

function stringToObject(str, endofkey, endofvalue) {
	const obj = {};
	const keyvalues = ((str && str.split && str.trim) ? str.trim().split(endofvalue) : null);
	keyvalues.forEach((keyvalue) => {
		const spl = ((keyvalue.split && keyvalue.trim) ? keyvalue.trim().split(endofkey) : null);
		const key = (spl && spl[0]);
		let val = (spl && spl[1]);
		val = (((val && val.length) && val.length > 0) ? val : `MISSING-KEY-${key}`);
		obj[key] = val;
	});
	return obj;
}

export default {
	objFromString(str, endofkey, endofvalue) {
		return stringToObject(str, endofkey, endofvalue);
	},
	__testStringToObject(str, endofkey = ':', endofvalue = ',') {
		/* To split a string containing ':' and ',' so that some of these chars
		are preserved, some custom separators are used:
		"key:value, key2:value" is then supplied with custom separators:
		"key__ENDOFKEY__value__ENDOFVALUE"*/
		return stringToObject(str, endofkey, endofvalue);
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/utils/textkeys.js